import { getFunctions, httpsCallable } from "firebase/functions";
import app from "../firebaseConfig";

const functions = getFunctions(app);
const sendEmailFunction = httpsCallable(functions, "sendEmail");

const YOUR_EMAIL = "laurence.klein89@gmail.com";

export async function sendEmailToRecruiter(firstName, email, message) {
  if (!firstName || !email || !message) {
    console.error("Missing required parameters");
    return;
  }

  const subject = `Enquiry Received - Laurence Klein`;
  const emailBody = `
    Hi ${firstName},<br><br>
    Thank you for your message. This is a confirmation that I've received your enquiry and will respond within one business day.<br><br>
    <strong>Your message:</strong><br>
    "${message}"<br><br>
    Kind regards,<br>
    Laurence Klein<br>
    Digital Systems & Operations<br>
    laurence.klein89@gmail.com
  `;

  const selfEmailBody = `
    <strong>From:</strong> ${firstName} (${email})<br><br>
    <strong>Message:</strong><br>${message}
  `;

  try {
    const [contactResult, selfResult] = await Promise.allSettled([
      sendEmailFunction({ email, subject, emailBody }),
      sendEmailFunction({
        email: YOUR_EMAIL,
        subject: `Portfolio Contact - ${firstName}`,
        emailBody: selfEmailBody,
      }),
    ]);

    if (contactResult.status === "fulfilled" && contactResult.value.data.success) {
      console.log("Contact email sent successfully.");
    } else {
      console.error("Failed to send contact email:", contactResult.reason || contactResult.value?.data?.error);
    }

    if (selfResult.status === "fulfilled" && selfResult.value.data.success) {
      console.log("Self copy email sent successfully.");
    } else {
      console.error("Failed to send self copy:", selfResult.reason || selfResult.value?.data?.error);
    }
  } catch (err) {
    console.error("Unexpected error sending emails:", err);
  }
}